import type { ResourceCategory, ResourceFileType } from '@/types'

export const resourceCategoryLabels: Record<ResourceCategory, string> = {
  job_search_tracking_tools: 'Job Search Tracking Tools',
  personal_branding_and_linkedin_strategy: 'Personal Branding and LinkedIn Strategy',
  networking_and_professional_communication: 'Networking and Professional Communication',
  working_with_recruiters: 'Working with Recruiters',
  financial_and_career_path_guidance: 'Financial and Career Path Guidance',
  career_transition_roadmaps_and_wellbeing: 'Career Transition Roadmaps and Wellbeing',
}

export const resourceCategoryColors: Record<ResourceCategory, string> = {
  job_search_tracking_tools: 'bg-blue-100 text-blue-700',
  personal_branding_and_linkedin_strategy: 'bg-purple-100 text-purple-700',
  networking_and_professional_communication: 'bg-emerald-100 text-emerald-700',
  working_with_recruiters: 'bg-amber-100 text-amber-700',
  financial_and_career_path_guidance: 'bg-cyan-100 text-cyan-700',
  career_transition_roadmaps_and_wellbeing: 'bg-rose-100 text-rose-700',
}

export const resourceFileTypeLabels: Record<ResourceFileType, string> = {
  pdf: 'PDF',
  excel: 'Excel',
}

export const resourceFileTypeColors: Record<ResourceFileType, string> = {
  pdf: 'bg-red-100 text-red-700',
  excel: 'bg-emerald-100 text-emerald-700',
}
